import { render, staticRenderFns } from "./TemplateComposerCard.vue?vue&type=template&id=9de6b89a&scoped=true&"
import script from "./TemplateComposerCard.vue?vue&type=script&lang=ts&"
export * from "./TemplateComposerCard.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateComposerCard.vue?vue&type=style&index=0&id=9de6b89a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de6b89a",
  null
  
)

export default component.exports